import React from 'react';

interface TextAreaButtonsProps {
  showClearButton: boolean;
  showSubmitButton: boolean;
  clearButtonText: string;
  submitButtonText: string;
  value: string;
  onClear: () => void;
  onSubmit: () => void;
  children?: React.ReactNode;
}

export const TextAreaButtons: React.FC<TextAreaButtonsProps> = ({
  showClearButton,
  showSubmitButton,
  clearButtonText,
  submitButtonText,
  value,
  onClear,
  onSubmit,
  children
}) => {
  const hasButtons = showSubmitButton || showClearButton || Boolean(children);
  if (!hasButtons) return null;

  return (
    <div className="textarea-component__buttons">
      {showClearButton && value && (
        <button
          type="button"
          className="textarea-component__button textarea-component__button--clear"
          onClick={onClear}
          aria-label="Clear textarea"
        >
          {clearButtonText}
        </button>
      )}
      {children}
      {showSubmitButton && (
        <button
          type="button"
          className="textarea-component__button textarea-component__button--submit"
          onClick={onSubmit}
          disabled={!value.trim()}
        >
          {submitButtonText}
        </button>
      )}
    </div>
  );
};
